// extracted by mini-css-extract-plugin
export default {"container":"PromoCsMoney_container__N+F2H"};